// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__34IzM","info":"UpdateTermsInfo_info__1TydY"};